module.exports = __webpack_public_path__ + "assets/img/背景-min.1e67ba2b.png";